import { createStore } from 'effector'
import { ConfirmationResult } from '@firebase/auth'
import { objectToCamelCase } from '@finanso/react-uikit'

import {
  $setPhone,
  $setName,
  $setPendingFirebase,
  $setCode,
  $setPermit,
  $setAuthType,
  $authThirdParty,
  $setTimeoutSendCode,
  $setAuthMethod,
  firebaseSendCodeFx,
  firebaseValidationCodeFx,
  $authThirdPartyLogin,
  $setAuthQuery,
  $setAuthToken,
  AuthType,
  $getValidatePhone,
  $setSendCodeType,
  regSendCodeFx,
  postRegSendCallFx,
  postRegSendSmsFx,
  postRegValidateFx,
  clearValidateFx,
  postRegValidateCallFx, $setCodeError, $postValidate, setPhoneErrorFx, postRegFx, $loginToken,
} from './event'
import { AuthMethod } from './type'
import {
  GetValidatePhoneRes,
  SendCodeType,
  AuthQuery,
  PostRegValidateRes,
  PostRegValidateCallRes,
  PostValidateRes,
} from '../../services/api/Auth'
import { AuthEventError } from '@firebase/auth/dist/src/model/popup_redirect'

export const $authToken = createStore<string>('')
  .on($authThirdParty.done, (_, { result }) => result.value.data.form.result)
  .on($authThirdPartyLogin.done, (_, { result }) => result.value.data.form.result.token)
  .on(postRegFx.done, (_, { result }) => result.value.data.token)
  .on($loginToken.done, ((_, { result }) => result.value.data.token))
  .on($setAuthToken, (_, authToken) => authToken)
export const $authType = createStore<AuthType>(AuthType.NULL)
  .on($setAuthType, (_, authType) => authType)
export const $authMethod = createStore<AuthMethod>(AuthMethod.INPUT)
  .on($setAuthMethod, (_, method) => method)
export const $phone = createStore<string>('')
  .on($setPhone, (_, phone) => phone)
export const $code = createStore<string>('')
  .on($setCode, (_, code) => code)
export const $name = createStore<string>('')
  .on($setName, (_, name) => name)
export const $isPermit = createStore<boolean>(false)
  .on($setPermit, (_, permit) => permit)
export const $authQuery = createStore<AuthQuery>({})
  .on($setAuthQuery, (_, query) => query)
export const $sendCodeType = createStore<SendCodeType>('' as SendCodeType)
  .on($setSendCodeType, (_, sendCodeType) => sendCodeType)

export const $timeoutSendCode = createStore<string>('')
  .on($setTimeoutSendCode, () => {
    const time = new Date()
    const timeout = new Date(time.setMinutes(time.getMinutes() + 1))
    return timeout.toISOString()
  })

export const $regValidate = createStore<Partial<PostRegValidateRes>>({})
  .on(postRegValidateFx.fail, (_, { error }) =>
    objectToCamelCase(error.error.data) as PostRegValidateRes,
  )
  .on(postRegValidateFx.done, () => ({ status: true }))
  .on(clearValidateFx, () => ({ status: true }))

export const $sendCodeLoading = createStore<boolean>(false)
  .on(regSendCodeFx.pending, (_, pending) => pending)
  .on(firebaseSendCodeFx.pending, (_, pending) => pending)
  .on(postRegSendCallFx.pending, (_, pending) => pending)
  .on(postRegSendSmsFx.pending, (_, pending) => pending)
  .on(postRegValidateFx.pending, (_, pending) => pending)

export const $isPendingFirebase = createStore<boolean>(false)
  .on($setPendingFirebase, (_, status) => status)
  .on($authThirdParty.pending, (_, pending) => pending)
  .on(firebaseSendCodeFx.pending, (_, pending) => pending)

export const $authFirePhone = createStore<ConfirmationResult | null>(null)
  .on(firebaseSendCodeFx.done, (_, { result }) => result)
  .on(firebaseSendCodeFx.fail, (_, { error }) => {
    // eslint-disable-next-line no-console
    console.error('Error FB signInWithPhoneNumber:', error)
    window.recaptchaVerifier.render().then((widgetId: number) => {
      window.grecaptcha.reset(widgetId)
    })
    return null
  })

export const $codeError = createStore<string>('')
  .on(firebaseValidationCodeFx.fail, (_, props) => {
    const error: AuthEventError = props?.error as any
    return error?.code.replace(/[^\w]/g, '.').toLowerCase() || 'auth.fb.phone.error.any'
  })
  .on(firebaseSendCodeFx.fail, (_, props) => {
    const error: AuthEventError = props?.error as any
    return error?.code.replace(/[^\w]/g, '.').toLowerCase() || 'auth.fb.phone.error.any'
  })
  .on($authThirdPartyLogin.fail, (_, { error }: any) => error.error.data?.form?.error)
  .on(postRegValidateCallFx.fail, (_, { error }) =>
    objectToCamelCase(error.error.data as PostRegValidateCallRes).message.callCode[0],
  )
  .on($setCodeError, (_, error) => error)
  .on(postRegValidateFx.fail, (_, { error }) =>
    objectToCamelCase(error.error.data as PostRegValidateRes).message?.smsCode[0],
  )

export const $phoneError = createStore<string>('')
  .on($postValidate.fail, (_, { error }) =>
    objectToCamelCase(error.error.data as PostValidateRes).message?.phone[0] !== 'error.phone.exist' ? 'error.phone.not.exist' : '',
  )
  .on($postValidate.done, () => 'error.phone.not.exist')
  .on(setPhoneErrorFx, (_, error) => error)

export const $authValidate = createStore<Partial<PostValidateRes>>({})
  .on($postValidate.fail, (_, { error }) => objectToCamelCase(error.error.data as PostValidateRes))

export const $validatePhone = createStore<Partial<GetValidatePhoneRes>>({})
  .on($getValidatePhone.done, (_, { result }) => result.value.data)
